import Axios from 'axios';
import getEncryptedApiKey from './getEncryptedApiKey';

export default function getGeoLocation() {
  const headers = {
    Accept: 'application/json',
    'X-Authorization': getEncryptedApiKey(),
  };

  if (process.env.NODE_ENV === 'development') {
    const devHeader = process.env.VUE_APP_DEV_HEADER.split(':');
    headers[devHeader[0]] = devHeader[1];
  }

  return Axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: {
      ...headers,
    },
  }).get('ip-location');
}
